<script>
    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule";

    /**
 *
 *
 *
 */

    /*                */
    let { benefitDiscountValuePercent, benefitId = null } = $props();
    const contentDresonRule = getContext(contentDresonRuleCtxKey);

    const contentDresonRuleParam = contentDresonRule ? `&contextDreson=${contentDresonRule}` : "";

    /*                                                                                                           */
    const benefitBadgeUrl = `/benefit-sheet/sheet/reco/${benefitId}?useOcSheet=true${contentDresonRuleParam}`;
</script>

<oc-tag-v1
    data-oc-sheet-v1-create
    data-oc-sheet-v1-create.base64-url={btoa(benefitBadgeUrl)}
    data-oc-sheet-v1-create.id="reco_cinema_benefit_badge_{benefitId}"
    data-testid="reco_cinema_benefit_badge_{benefitId}"
    class="reco_cinema__customer-benefit-badge oc-mt-25"
    size="50"
    variant="sale"
    show-info-icon
    >{benefitDiscountValuePercent}
</oc-tag-v1>
